<template>
  <div class="card">
    <div class="card-header">Clientes</div>

   
     
        <b-field class="file" v-if="permiso==1">
          <b-upload v-model="file">
            <a class="button is-info">
              <i class="fa fa-file-excel-o" aria-hidden="true"></i>
            </a>
          </b-upload>

          <span class="file-name" v-if="file">{{ file.name }}</span>
        </b-field>
        <div class="card-body">
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Nombre:</label>
            <div class="col-sm-10">
              <input
                type="nombre"
                v-model="cliente.nombre"
                class="form-control"
                placeholder="Nombre del Cliente"
              >
            </div>
          </div>
          <div class="form-group row">
            <label class="col-sm-2 col-form-label">Apellido:</label>
            <div class="col-sm-10">
              <input
                type="text"
                class="form-control"
                v-model="cliente.apellido"
                placeholder="Apellido"
              >
            </div>
          </div>
          <div class="form-group row">
            <label for="inputEmail3" class="col-sm-2 col-form-label">Teléfono:</label>
            <div class="col-sm-10">
              <input
                type="text"
                class="form-control"
                v-model="cliente.telefono"
                placeholder="Teléfono"
              >
            </div>
          </div>
          <div class="form-group row">
            <label for="inputEmail3" class="col-sm-2 col-form-label">Facebook:</label>
            <div class="col-sm-10">
              <input
                type="text"
                class="form-control"
                v-model="cliente.facebook"
                placeholder="Facebook"
              >
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <button class="btn btn-primary" @click="saveCliente">
                <i class="fa fa-save"></i>
                Guardar
              </button>
               
            </div>
            <div class="col-md-4" v-if="edit">
            <button class="btn btn-danger"  @click="cancelarEdicion">
                  <i class="fa fa-times"></i>
                 Cancelar Edición
                </button>
            </div>
          </div>
          <br>

          <!--  <div class="form-group row">
        <label class="col-sm-2 col-form-label">Buscar alumno:</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" placeholder="Nombre">
        </div>
      </div>
          </div>-->
          <div class="form group row">
            <label class="col-sm-4 col-form-label">Búsqueda por Nombre:</label>
            <div class="col-sm-6">
              <input type="text" class="form-control" v-model="busqueda_nombre"
              @keypress="clear_busqueda_apellido"
              >
            
            </div>
          </div>
          <br>
          <div class="form group row">
            <label class="col-sm-4 col-form-label">Búsqueda por Apellidos:</label>
            <div class="col-sm-6">
              <input
                type="text"
                class="form-control"
                @keypress="clear_busqueda_nombre"
                v-model="busqueda_apellidos"
              >
            </div>
          </div>
          <br>

          <div class="table-responsive">
            <table class="table table-striped">
              <tr>
                <th @click="sort('nombre')">Nombre</th>
                <th @click="sort('apellido')">Apellido</th>

                <th @click="sort('telefono')">Teléfono</th>
                <th @click="sort('email')">Facebook</th>
              </tr>
              <tbody v-if="lista_clientes.length>0">
                <tr v-for="(obj,index) in sortedClientes" :key="index">
                  <td>{{obj.nombre}}</td>
                  <td>{{obj.apellido}}</td>

                  <td>{{obj.telefono}}</td>
                  <td>{{obj.facebook}}</td>

                  <td>
                  <!--  <a
                      style="color: gray;cursor:pointer"
                      class="fa fa-search"
                      @click="verAbonos(obj.idcliente,obj.nombre+' '+obj.apellido)"
                    ></a>-->
                    <a
                      v-if="permiso==1"
                      style="margin-right: 10px; color:blue;cursor:pointer"
                      class="fa fa-edit"
                      @click="editCliente(obj.idcliente)"
                    ></a>
                    <a
                      v-if="permiso==1"
                      style="color: red;cursor:pointer"
                      class="fa fa-trash"
                      @click="eliminarCliente(obj)"
                    ></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <button @click="prevPage">Anterior</button>
          <button @click="nextPage">Siguiente</button>
        </div>
     

      
    
  </div>
</template>
<script>
import { url } from "../main.js";
import { Datetime } from "vue-datetime";
export default {
  data() {
    return {
      idcliente:0,
      nombre_cliente:"",
       tabIndex: 0,
      file: null,
     edit:false,
      permiso: 0,
      currentSort: "",
      currentSortDir: "",
      pageSize: 10,
      currentPage: 1,
      cliente: {
        idcliente: 0,

        nombre: "",
        apellido: "",

        telefono: "",
        facebook: ""
      },
     
      busqueda_nombre: "",
      busqueda_apellidos: "",
      lista_clientes: []
     
    };
  },
   components: {
    datetime: Datetime
  },
  mounted() {
    this.permiso = localStorage.getItem("permission");
    this.verClientes();
  },
  computed: {
    sortedClientes() {
      if (this.busqueda_nombre != "") {
        return this.lista_clientes.filter(cliente => {
          console.log(cliente);
          return cliente.nombre
            .toUpperCase()
            .match(this.busqueda_nombre.toUpperCase());
        });
      } else {
        if (this.busqueda_apellidos != "") {
          return this.lista_clientes.filter(cliente => {
            console.log(cliente);
            return cliente.apellido
              .toUpperCase()
              .match(this.busqueda_apellidos.toUpperCase());
          });
        } else {
          return this.lista_clientes
            .sort((a, b) => {
              let modifier = 1;
              if (this.currentSortDir === "desc") modifier = -1;
              if (a[this.currentSort] < b[this.currentSort])
                return -1 * modifier;
              if (a[this.currentSort] > b[this.currentSort])
                return 1 * modifier;
              return 0;
            })
            .filter((row, index) => {
              let start = (this.currentPage - 1) * this.pageSize;
              let end = this.currentPage * this.pageSize;
              if (index >= start && index < end) return true;
            });
        }
      }
    },
    
    
    
  
  },

  methods: {
     
    verClientes() {
      this.axios
        .get(url + "apiClientes.php/get_clientes")
        .then(respuesta => {
          console.log(respuesta);
          this.lista_clientes = respuesta.data;

          console.log(this.lista_clientes);
        })
        .catch(function() {
          console.log("FAILURE ver!!");
        });
    },
    saveCliente() {
      if (this.file != null) {
        console.log(this.file);
        this.uploadFile(this.file);
      } else {
        if (this.validarcampos()) {
          if (this.cliente != null) {
            console.log(this.cliente);
            this.axios
              .post(url + "apiClientes.php/save_cliente", this.cliente)
              .then(respuesta => {
                console.log(respuesta);
                if (respuesta.data.status === 200) {
                  this.$swal(respuesta.data.msg);
                  this.verClientes();
                  this.limpiarcampos();
                }
              })
              .catch(function() {
                console.log("FAILURE!!");
              });
          }
        }else{
          this.$swal("Debe ingresar nombre y apellido");
        }
      }
    },
    limpiarcampos() {
      this.cliente = {};
      this.nombre_cliente="";
    },
    validarcampos() {
      if (
        this.cliente.nombre == "" ||
        this.cliente.apellido == "" 
        //||
       // this.cliente.telefono == ""
      ) {
        return false;
      } else {
        return true;
      }
    },
    clear_busqueda_nombre() {
      this.busqueda_nombre = "";
    },
    clear_busqueda_apellido() {
      this.busqueda_apellidos = "";
    },
    prevPage() {
        if(this.currentPage > 1) this.currentPage--;
    },
    nextPage() {
      if((this.currentPage*this.pageSize) < this.lista_clientes.length) this.currentPage++;
    },
     sort(s) {
       console.log('sort')
    //if s == current sort, reverse
    if(s === this.currentSort) {
      this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
    }
    this.currentSort = s;
  },
    editCliente(idcliente){

       this.axios
        .get(url + "apiClientes.php/get_cliente/"+idcliente)
        .then(respuesta => {
          console.log(respuesta);
          this.cliente = respuesta.data;
          this.edit=true;
         
     
        });

    },
    eliminarCliente(cliente){
        this.$swal({
        title: "Confirmación",
        text: "¿Desea eliminar al cliente?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "Cancelar",
        confirmButtonText: "Sí, eliminar"
      }).then(result => {
        if (result.value) {
          this.$http
            .post(url + "apiClientes.php/delete_cliente",cliente)
            .then(respuesta => {
              console.log(respuesta);

              if (respuesta.data.status === 200) {
                this.$swal("Cliente Eliminado");
                this.verClientes();
              }
            });
        }
      });

    },
    
    
     uploadFile(file) {
      var formData = new FormData();
      formData.append("clientes", file);

      this.axios
        .post(
          url + "apiClientes.php/up_clientes",
          formData,

          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        )
        .then(respuesta=> {
          console.log("SUCCESS!!");
          this.file= null;
           this.verClientes();
         
        })
        .catch(respuesta=> {
          console.log("FAILURE!!");
        
        });
     },
  cancelarEdicion()
  {
    this.edit=false;
    this.cliente={};
  }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/clientes.vue